import React, { useState } from 'react'
import styled from 'styled-components'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ReportTypesPage from './ReportTypesPage'
import ReportPage from './ReportPage'

const ReportingHub = () => {
  const [selectedType, setSelectedType] = useState(null)

  if (!selectedType) {
    return <ReportTypesPage onSelectType={setSelectedType} />
  }

  return (
    <div>
      <BackLink onClick={() => setSelectedType(null)}>
        <ArrowBackIcon style={{ fontSize: 16 }} />
        All Report Types
      </BackLink>
      <ReportPage reportType={selectedType} />
    </div>
  )
}

export default ReportingHub

const BackLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.grey?.[800] || '#999'};
  padding: 0 12px;
  margin-top: -8px;
  margin: 0;

  &:hover { color: ${({ theme }) => theme.colors.primary}; }
`
